import { Pipe, PipeTransform } from '@angular/core';

export interface IKuiPaginatePipeOptioms {
    page?: number;
    perPage?: number;
}

@Pipe({
    name: 'paginate',
})
export class KuiPaginatePipe implements PipeTransform {
    transform(value: any[], options: IKuiPaginatePipeOptioms = { page: 1, perPage: 10 }): any {
        options.page = options.page || 1;
        options.perPage = options.perPage || 10;

        const start = options.page === 1 ? 0 : ((options.page - 1) * options.perPage);
        const end = (options.page * options.perPage);

        return value.slice(start, end);
    }
}
